import { AlertTriangle } from "lucide-react";

/**
 * Buyer-focused "common issues / signs you need this service" panel.
 * Deliberately avoids online diagnosis and always suggests a proper inspection.
 */
export default function CommonIssues({
  title = "Common reasons customers get in touch",
  intro,
  items = [],
  note = "This list is a general guide. We do not diagnose a specific fault online — where a system fault is suspected, we recommend arranging an on-site inspection.",
}) {
  return (
    <section className="fss-section bg-white" data-testid="common-issues">
      <div className="fss-container">
        <div className="max-w-3xl mb-8">
          <div className="fss-overline">Buyer questions</div>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-semibold text-slate-900 leading-tight">
            {title}
          </h2>
          {intro && (
            <p className="mt-3 text-slate-600 leading-relaxed">{intro}</p>
          )}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((it, i) => (
            <div
              key={i}
              className="bg-slate-50 border-l-2 border-red-600 p-5 flex items-start gap-3"
              data-testid={`common-issue-${i}`}
            >
              <AlertTriangle className="w-4 h-4 text-red-600 shrink-0 mt-0.5" />
              <span className="text-sm text-slate-800 leading-relaxed">{it}</span>
            </div>
          ))}
        </div>
        <div className="mt-6 max-w-3xl text-xs text-slate-500 italic leading-relaxed">
          {note}
        </div>
      </div>
    </section>
  );
}
